// Nettoyage du "script variable" (template) avant affichage.
//
// Pour les formats VISUELS, le backend tombe parfois sur la description
// technique de tournage brute dans `script_template` (ex:
//   "3 plan(s) : Plan 1 (19s) : plan moyen / face caméra / fixe — <contenu>")
// Ces marqueurs de cadrage appartiennent à la TRAME (structure des beats),
// pas au script à dire : ils nuisent à la compréhension dans l'onglet
// "Variables". On retire les en-têtes techniques en gardant le contenu
// rédigé qui suit. Les templates "normaux" (script avec [Variables]) ne
// contiennent pas ces marqueurs et sont laissés intacts.
export function cleanScriptTemplate(tmpl) {
  if (!tmpl) return ''
  let t = String(tmpl)
  // "3 plan(s) :" / "1 plan :"
  t = t.replace(/\d+\s*plans?\s*\(s\)\s*:\s*/gi, '')
  t = t.replace(/\d+\s*plans?\s*:\s*/gi, '')
  // "Plan 1 (19s) : plan moyen / face caméra / fixe —"  → on garde ce qui suit le tiret
  t = t.replace(/Plan\s*\d+\s*\([^)]*\)\s*:\s*[^—\n;]*[—–]\s*/gi, '')
  // "Plan 1 (19s) :" résiduel (sans tiret)
  t = t.replace(/Plan\s*\d+\s*\([^)]*\)\s*:\s*/gi, '')
  // Sépare proprement les plans multiples restants
  t = t.replace(/\s*;\s*/g, '\n')
  // Compactage des espaces / lignes
  t = t.replace(/[ \t]{2,}/g, ' ').replace(/\n{3,}/g, '\n\n').trim()
  return t
}
